import React, {useEffect, useState} from "react";
// custom
import Layout from "../../components/common/layout";
// Api
import {getContentList} from "../../services/contentservice";
// third party
import toast from "react-hot-toast";
import {marked} from "marked";
import {Container, Row} from "react-bootstrap";

const PrivacyAndPolicy = () => {
    const [privacyNPolicy, setPrivacyNPolicy] = useState();

    /**
     * @function fetchContentList
     * @param
     * @description get content List
     */
    const fetchContentList = async () => {
        try {
            const result = await getContentList();
            if (result?.data?.data) {
                setPrivacyNPolicy(result?.data?.data?.privacy_policy);
            } else {
                setPrivacyNPolicy();
                toast.error(result?.response?.data?.message || "Something went wrong");
            }
        } catch (error) {
            setPrivacyNPolicy();
            toast.error(error || error?.response?.data?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        fetchContentList();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        document.title = "Privacy | Play Sports Together";
    }, []);

    return (
        <Layout>
            <Container className="px-0 px-sm-5 my-5">
                <Row className="px-5 mx-0">
                    {privacyNPolicy && (
                        <div dangerouslySetInnerHTML={{__html: marked(privacyNPolicy)}} />
                    )}
                </Row>
            </Container>
        </Layout>
    );
};

export default PrivacyAndPolicy;
